import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss'],
  standalone: false
})
export class CustomerSearchComponent implements OnInit {
   leadsOnly = false;
  internal = false;
  loading = false;
  showEmptyMessage = false;
  pageSize = 10;
  first = 0;
  totalRecords = 0;

  paginatedResults: any[] = [];
  customerTypes = [
    { label: 'Both', value: 'both' },
    { label: 'Commercial', value: 'commercial' },
    { label: 'Residential', value: 'residential' }
  ];
  showResults: boolean = false;

  businessForm: FormGroup;
  rangeText = '';
  isFirstPage = true;
  isLastPage = false;
  
  filterOptions = [
    { label: 'Residential', value: 'residential' },
    { label: 'Commercial', value: 'commercial' }
  ];

  selectedFilters: string[] = ['residential', 'commercial'];

  sortOptions = [
    { label: 'Date Added', value: 'date' },
    { label: 'Customer Name', value: 'name' }
  ];



  pageSizeOptions = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 }
  ];

  order1 =  {
      orderNumber: 'DSI206079008',
      orderPlaced: '12:55 PM 9/19/2025',
      campaign: 'ATT SMB + DTV MSO',
      creditResult: 'No Credit Check',
      customerName: 'Mike Smith',
      phone: '987-654-3210',
      email: 'msmith@gmail.com',
      address: '12345 Main St, Des Moines, Iowa 50254',
      agent: 'Andrew Bro',
      dealer: 'DSI Comm Express - COMM',
      products: 'Internet; Wireless; DTV Video'
    }

    order2 = {
      orderNumber: 'DSI206079009',
      orderPlaced: '10:20 AM 9/18/2025',
      campaign: 'ATT Wireless',
      creditResult: 'Approved',
      customerName: 'John Doe',
      phone: '555-321-9876',
      email: 'jdoe@gmail.com',
      address: '6789 Elm St, Dallas, Texas 75001',
      agent: 'Sarah Lee',
      dealer: 'DSI Comm Express - COMM',
      products: 'Wireless'
    }

  searchResults = Array.from({ length: 30 }, (_, index) => {
    return index % 2 === 0 ? this.order1 : this.order2;
  });
  showCustomerLookup: boolean = false;

  

  ngOnInit() {
    this.totalRecords = this.searchResults.length;
    this.updatePagination();
  }

  constructor(private fb: FormBuilder) {
    this.businessForm = this.fb.group({
      businessName: [
        '',
        [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]
      ],
      firstName: [
        '',
        [Validators.pattern(/^[a-zA-Z\s]*$/)]
      ],
      lastName: [
        '',
        [Validators.pattern(/^[a-zA-Z\s]*$/)]
      ],
      accountOrderNumber: [
        '',
        [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]
      ],
      salespersonFullName: [
        '',
        [Validators.pattern(/^[a-zA-Z0-9\s]*$/)]
      ],
      phoneNumber: [
        '',
        [
          Validators.pattern(/^[0-9]*$/),
          Validators.maxLength(10)
        ]
      ]
    });
  }

  onClear() {
    this.leadsOnly = false;
    this.internal = false;
    this.showEmptyMessage = false;
    this.loading = false;
    // reset form controls here
  }

  onSearch() {
    const hasInput = true; // replace with real validation

    if (!hasInput) {
      this.showEmptyMessage = true;
      return;
    }

    this.showEmptyMessage = false;
    this.loading = true;
    this.showResults = true;
    setTimeout(() => {
      this.loading = false;
      this.showResults = true;
    }, 2000);

  }

  

  onPageChange(event: any) {
    this.first = event.first;
    this.pageSize = event.rows;
    this.updatePagination();
  }

  updatePagination() {
    this.paginatedResults = this.searchResults.slice(
      this.first,
      this.first + this.pageSize
    );
  }

  onPageSizeChange() {
    // this.first = 0; 
    // this.updatePagination();  
  }

  goPrev() {
    if (this.first === 0) return;
    this.first -= this.pageSize;
    this.updatePagination();
  }

  goNext() {
    if (this.first + this.pageSize >= this.totalRecords) return;
    this.first += this.pageSize;
    this.updatePagination();
  }

  customerLookup() {
    this.showCustomerLookup = true;
  }

}
